export default "__VITE_ASSET__6uF4UW_v__"